
import { Download, Print } from "@mui/icons-material";
import { Button, Grid } from "@mui/material";
import React from "react";

type ActionsBarProps = {
  onDownload?: () => void;
  onPrint?: () => void;
  downLoadLabel?: string;
  printlabel?: string;
  showDowload?: boolean,
  showPrint?: boolean
  disabled?: boolean
}

export const ActionsBar: React.FC<ActionsBarProps> = (
  {
    onDownload,
    onPrint,
    downLoadLabel = "Descargar",
    printlabel = 'Imprimir',
    showDowload = true,
    showPrint = true,
    disabled
  }

) => {
  return (
    <>

      <Grid container spacing={3}>
        <Grid item >
          <Grid container spacing={1} justifyContent={'flex-end'} alignItems={'center'}>
            {showPrint && (
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<Print />}
                  onClick={onPrint}
                  disabled={disabled}
                >
                  {printlabel}
                </Button>

              </Grid>

            )}

            {
              showDowload && (
                <Grid item>
                  <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={<Download />}
                    onClick={onDownload}
                    disabled={disabled}
                  >
                    {downLoadLabel}
                  </Button>
                </Grid>

              )
            }



          </Grid>
        </Grid>


      </Grid>
    </>

  )
}
export default ActionsBar